import { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";
import { DynamicImportModule } from "@modules/dynamic_import/DynamicImportModule";
import {
    DynamicModuleDefinition,
    ExtractModuleType,
} from "@modules/dynamic_import/types";

import { SDK_MODULES } from "../constants";
import {
    AuthenticationSdkDefinition,
    CartSdkDefinition,
    DiscountSdkDefinition,
    GiftRegistrySdkDefinition,
    ProductsSdkDefinition,
    ReviewsSdkDefinition,
    RewardsSdkDefinition,
    WishlistsSdkDefinition,
} from "./SdkDynamicModulesDefinitions";

export class SdkDynamicModulesManager {
    private readonly dynamicImportManager: DynamicImportManager;

    private readonly definitions = {
        [SDK_MODULES.GIFT_REGISTRY]: GiftRegistrySdkDefinition,
        [SDK_MODULES.WISHLISTS]: WishlistsSdkDefinition,
        [SDK_MODULES.REVIEWS]: ReviewsSdkDefinition,
        [SDK_MODULES.DISCOUNTS]: DiscountSdkDefinition,
        [SDK_MODULES.REWARDS]: RewardsSdkDefinition,
        [SDK_MODULES.CART]: CartSdkDefinition,
        [SDK_MODULES.AUTHENTICATION]: AuthenticationSdkDefinition,
        [SDK_MODULES.PRODUCTS]: ProductsSdkDefinition,
    } satisfies Omit<
        Record<SDK_MODULES, DynamicModuleDefinition>,
        SDK_MODULES.COMMON
    >;

    constructor(dynamicImportModule: DynamicImportModule) {
        this.dynamicImportManager =
            dynamicImportModule.exports.dynamicImportManager;

        Object.values(this.definitions).forEach((definition) => {
            this.dynamicImportManager.register(definition);
        });
    }

    public fetch(
        moduleName: Exclude<SDK_MODULES, SDK_MODULES.COMMON>
    ): Promise<void> {
        return this.dynamicImportManager.fetch({
            definition: this.definitions[moduleName],
        });
    }

    public import<T extends Exclude<SDK_MODULES, SDK_MODULES.COMMON>>(
        moduleName: T
    ) {
        return this.dynamicImportManager.importDefault<
            ExtractModuleType<(typeof this.definitions)[T]>["default"]
        >(this.definitions[moduleName]);
    }
}
